var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallersStatusRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#EC3E49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.762 8C18.0343 8.1506 18.2337 8.30661 18.2331 8.64929L17.6096 14.4689C17.7367 15.1269 18.6537 15.1918 18.8272 14.5239C19.065 12.9515 19.1245 11.3186 19.3614 9.75099C19.3671 9.71312 19.3481 9.66382 19.4183 9.69207C19.5978 9.76452 20.0656 10.1415 20.2368 10.2828C22.0017 11.7404 23.1012 14.058 23.222 16.3591C23.2339 16.5869 23.2566 17.1451 23.2205 17.3444C23.2125 17.3886 23.2006 17.4181 23.1622 17.4427H8.30649C8.2678 17.4181 8.25589 17.3883 8.24816 17.3444C8.21184 17.1445 8.23476 16.5881 8.24667 16.3591C8.38328 13.6906 9.80447 11.1064 12.0504 9.69207C12.1329 9.68125 12.0995 9.69839 12.1073 9.75099C12.3445 11.3186 12.4037 12.9518 12.6415 14.5239C12.815 15.1918 13.732 15.1269 13.8591 14.4689L13.2356 8.64929C13.235 8.30631 13.4344 8.1506 13.7067 8H17.7617H17.762Z",
    fill: "#EC3E49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.8426V19.4491C7.1387 19.0625 7.41758 18.7574 7.83813 18.7012L23.5924 18.6997C24.7517 18.8467 24.7549 20.4384 23.5924 20.5917L7.83813 20.5902C7.41788 20.534 7.1387 20.2289 7 19.8423V19.8426Z",
    fill: "#EC3E49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallersStatusRed);
export default __webpack_public_path__ + "static/media/installersStatusRed.f0f9637a85dca58d8cf956f3789eb98c.svg";
export { ForwardRef as ReactComponent };